import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules.umd.js'
import { lessThan, greaterThan, validEmail, validNumber, presentOrFuture } from '@/utils/validation-utils.ts'

extend('lessThan', {
  validate(value, { length }) {
    return lessThan(value, { length })
  },
  params: ['length'],
  message: 'Must be less than {length} characters.'
});

extend('greaterThan', {
  validate(value, { length }) {
    return greaterThan(value, { length })
  },
  params: ['length'],
  message: 'Must be longer than {length} characters.'
});

extend('validEmail', {
  validate(value) {
    return validEmail(value);
  },
  message: 'Must be valid email, Ex. "email@blytzpay.com".'
});

extend('validNumber', {
  validate(value) {
    return validNumber(value)
  },
  message: 'Must be a valid number.'
});

extend('presentOrFuture', {
  validate(value) {
    return presentOrFuture(value)
  },
  message: 'Must be todays date or later.'
});


extend('required', required)